var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Hero',{attrs:{"imgLink":"/img/port.jpg"}}),_c('ServicesSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }